import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from 'react-bootstrap/Button'
import { ATIconButtonProps } from './FormComponentProps'

const ATIconButton: React.FC<ATIconButtonProps> = ({
  title = '',
  onClick,
  type = 'button',
  disabled = false,
  variant = 'primary',
  content,
  classes = '',
  icon = '',
  dataId = '',
}) => {
  const { t } = useTranslation(['translation'])
  return (
    <Button
      className={`${classes}`}
      onClick={onClick}
      variant={variant}
      aria-label={t(title)}
      title={t(title)}
      disabled={disabled}
      type={type}
      data-id={dataId}
    >
      {icon}
      {content !== '' ? content : ''}
    </Button>
  )
}

export default ATIconButton
